"use client";

import CarouselSection from "@/components/CarouselSection";
import { useTranslations } from "next-intl";

export default function CityBlogsClient({ blogPosts, formattedCity }) {
  const t = useTranslations("flight");
  const title = formattedCity
    ? `${formattedCity} ${t("blogPosts")}`
    : t("blogPosts");

  return (
    <CarouselSection
      title={title}
      description={t("blogDescription")}
      linkText={t("viewAll")}
      href="/blog/"
      preserveTrailingSlash={true}
      items={blogPosts}
      componentType="BlogCard"
      componentProps={{}}
    />
  );
}
